import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { NgClass, NgIf } from '@angular/common';
import { AuthService } from '../../services/auth.service';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, RouterLink, NgClass, NgIf],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})

export class LoginComponent implements OnInit {

  form!: FormGroup;
  submitted = false;
  passwordTextType!: boolean;
  authService: AuthService ;
  constructor(private readonly _formBuilder: FormBuilder, private readonly _router: Router ) {

    this.authService = inject(AuthService);

    if (this.authService.isAuthenticatedUser()) {
      this._router.navigate([environment.default_route]);
    }

  }

  onClick() {
    console.log('Button clicked');
  }

  ngOnInit(): void {
    this.form = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }

  get f() {
    return this.form.controls;
  }

  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }

  async onSubmit() {
    this.submitted = true;
    const { email, password } = this.form.value;

    if (this.form.valid) {
      const { email, password } = this.form.value;

       // Call the authentication service's login method
       if ( await this.authService.login(email, password) ) {
        // Navigate to the ProductListComponent upon successful login
         this._router.navigate([environment.default_route]);
      } else {
        // Handle authentication error (show error message, etc.)
      }

    }

    this._router.navigate([environment.default_route]);
  }
}
